<script setup></script>
<template>
  <div class="spinner">
    <i class="fa fa-spinner fa-spin"></i>
  </div>
</template>
<style scoped lang="scss">
div.spinner {
  font-size: 30px;
  text-align: center;
  color: #aaa;
  padding-top: 20px;
}
</style>